import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { Button, Header, Icon, Segment } from "semantic-ui-react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  MySelectInput,
  MySelectInputEdiciones,
  valor,
} from "../../app/common/form/MySelectInput";
import {
  CuotasConsultaFormValues,
  CuotasMod,
  CuotasModFormValues,
} from "../../app/models/CuotasMod";
import "./Operaciones_style.css";

import { SubMenuOExoneraciones } from "../Operaciones/MenuOperaciones";

import { toast } from "react-toastify";
import TablaExo from "./TablaExo";
import CreateExoneracion from "../Modals/CreateExoneracion";

export default observer(function Exoneraciones() {
  const {
    ExoneracionesStore,
    CuotasStore,
    CCTMovimientoReporteStore,
    modalStore,
  } = useStore();
  const { loadCourses } = CuotasStore;
  const { loadEditions } = CuotasStore;
  const { loadExoneraciones } = ExoneracionesStore;

  const { loadCuotas } = CuotasStore;
  const { CCTMovimientoByCodigo, reporte } = CCTMovimientoReporteStore;

  // CCTMovimientoRegistry.clear()

  const { loading } = CuotasStore;

  const [CuotasConsulta, setSGPersona] = useState<CuotasConsultaFormValues>(
    new CuotasConsultaFormValues()
  );

  function handleFormSubmit(CuotasMod: CuotasConsultaFormValues) {
    loadExoneraciones();
  }

  useEffect(() => {
    loadExoneraciones();
  }, []);

  let ActividadAcademica: object[] = [];

  let ediciones: object[] = [];

  loadCourses().then(function (result) {
    result.forEach((element) => {
      ActividadAcademica.push({
        text: element.nombre,
        value: element.codigoCurso,
      });
    });
  });

  var fun1 = () => {
    if (valor()) {
      ediciones = [];
      loadEditions(valor()).then(function (result) {
        result.forEach((element) => {
          ediciones.push({
            text: element.fechaDeInicioInscripcion,
            value: element.catCursosId,
          });
        });
      });
    }
  };

  return (
    <>
      <SubMenuOExoneraciones />
      <div>
        <div className="header_operaciones">
          <h1>Solicitud de Exoneración</h1>
          <Button
            floated="right"
            icon
            positive
            size="small"
            style={{ width: "70px" }}
            onClick={() => {
              modalStore.openModal(<CreateExoneracion names={""} />, 'mini');
            }}
          >
            <Icon name="add" />
          </Button>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="buscar_operaciones">
          <Formik
            enableReinitialize
            initialValues={CuotasConsulta}
            onSubmit={(values) => handleFormSubmit(values)}
          >
            {({ handleSubmit, isValid, isSubmitting, dirty }) => (
              <Form
                className="ui form"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <div className="form_buscar_operaciones">
                  <div>
                    <Header size="small" content="Maestría, Diplomado o Curso" />
                    <MySelectInputEdiciones
                      id=""
                      name="catcursoid"
                      placeholder=" "
                      options={ActividadAcademica}
                      functionevent={fun1}
                    />
                  </div>
                  <div>
                    <Header size="small" content="Edición" />
                    <MySelectInputEdiciones
                      id=""
                      name="catedicionid"
                      placeholder=" "
                      options={ediciones}
                    />
                  </div>
                  <div className="boton_buscar_operaciones">
                    <Button
                      loading={loading}
                      type="submit"
                      content="Buscar"
                      style={{ backgroundColor: "#15b3e8", color: "white" }}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <br></br>
        </div>
        <TablaExo />
        <br></br>
        <br></br>
        {/* <Button onClick={() => {
                  reporte(CCTMovimientoByCodigo)
              }}>Generar Reporte</Button> */}
      </div>
    </>
  );
});
